import "./App.css";
import Hero from "./hero/hero";
import Main from "./main/main";
import Footer from "./footer/footer";
function App() {
  return (
    <div className="App">
      
      <Hero />
      <Main />
      <Footer />
    </div>
  );
}

export default App;
